import styled from 'styled-components';
import { Button, FlexView, Row } from '@cuemath/comps';

export const Container = styled(FlexView)`
  && {
    display: flex;
    flex-direction: row;
    height: 100%;
  }
`;

export const SetupPanel = styled(FlexView)`
  && {
    width: 250px;
    min-width: 250px;
    border-right: 1px solid #eee;
    padding: 20px 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;

export const ChatPanel = styled(FlexView)`
  && {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`;

export const EmptyChat = styled(FlexView)`
  && {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #808080;
    font-size: 14px;
  }
`;

export const SetupLabel = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #555;
  margin-bottom: 4px;
`;

export const SetupInput = styled.input`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #0177ff;
  }
`;

export const SetupSelect = styled.select`
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  background: #fff;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #0177ff;
  }
`;

export const StartButton = styled(Button)`
  && {
    padding: 10px 16px;
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    background: linear-gradient(56.99deg, #0177ff 0%, #1f48d7 100%);
    border: none;
    border-radius: 4px;
    cursor: pointer;
    height: auto;
  }

  && > * {
    border: none;
    padding: 0;
    background: transparent;
  }

  &&:hover {
    opacity: 0.9;
    border: none;
  }

  &&:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// Chat area components
export const ChatContainer = styled(FlexView)`
  && {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`;

export const MessagesArea = styled(FlexView)`
  && {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 16px 20px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;

export const MessagesSpacer = styled(FlexView)`
  && {
    flex: 1;
  }
`;

export const InputRow = styled(Row)`
  && {
    display: flex;
    gap: 8px;
    padding: 12px 20px;
    border-top: 1px solid #eee;
  }
`;

export const ChatInput = styled.input`
  flex: 1;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 20px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #0177ff;
  }
`;

export const SendButton = styled.button`
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  background: #0177ff;
  border: none;
  border-radius: 20px;
  cursor: pointer;

  &:hover {
    background: #0160cc;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

export const TypingIndicator = styled.div`
  font-size: 12px;
  color: #808080;
  padding: 0 20px 4px;
  font-style: italic;
`;

// Message bubble components
export const BubbleRow = styled(Row)`
  && {
    display: flex;
    justify-content: ${({ $isCustomer }) => ($isCustomer ? 'flex-end' : 'flex-start')};
  }
`;

export const CustomerBubble = styled.div`
  max-width: 70%;
  padding: 10px 14px;
  background: #0177ff;
  color: #fff;
  border-radius: 16px 16px 4px 16px;
  font-size: 14px;
  line-height: 1.4;
  word-break: break-word;
`;

export const BotBubble = styled.div`
  max-width: 70%;
  padding: 10px 14px;
  background: #f0f0f0;
  color: #2b2b2b;
  border-radius: 16px 16px 16px 4px;
  font-size: 14px;
  line-height: 1.4;
  word-break: break-word;
`;

export const ButtonsContainer = styled(Row)`
  && {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 8px;
  }
`;

export const DispositionButton = styled.button`
  padding: 6px 12px;
  font-size: 12px;
  color: #0177ff;
  background: #fff;
  border: 1px solid #0177ff;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: #0177ff;
    color: #fff;
  }
`;

export const ListContainer = styled(FlexView)`
  && {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-top: 8px;
  }
`;

export const ListOption = styled.button`
  padding: 8px 12px;
  font-size: 13px;
  color: #2b2b2b;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  text-align: left;
  transition: all 0.15s ease;

  &:hover {
    border-color: #0177ff;
    color: #0177ff;
  }
`;

export const ImageContent = styled.img`
  max-width: 100%;
  border-radius: 8px;
  margin-top: 4px;
`;

export const ConfirmContainer = styled(Row)`
  && {
    display: flex;
    gap: 8px;
    margin-top: 8px;
  }
`;

export const ConfirmButton = styled.button`
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 600;
  border: 1px solid ${({ $yes }) => ($yes ? '#2AC3AA' : '#EA5959')};
  color: ${({ $yes }) => ($yes ? '#2AC3AA' : '#EA5959')};
  background: #fff;
  border-radius: 14px;
  cursor: pointer;

  &:hover {
    background: ${({ $yes }) => ($yes ? '#2AC3AA' : '#EA5959')};
    color: #fff;
  }
`;

export const DraftToggleLabel = styled(Row)`
  && {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
  }
`;

export const DraftToggleText = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #555;
`;

export const DraftHint = styled.div`
  font-size: 11px;
  color: #808080;
  margin-top: 4px;
  padding-left: 24px;
`;

export const ErrorText = styled.div`
  color: #ea5959;
  font-size: 13px;
`;

export const ResetButton = styled(StartButton)`
  background: #808080;
`;

export const TicketInfo = styled.div`
  font-size: 12px;
  color: #808080;
`;

export const DraftModeTag = styled.span`
  color: #e8a317;
`;

export const FormattedTextWrapper = styled.div`
  line-height: 1.6;
`;

// DebugPanel / TraceEventRow components

export const DebugPanelWrapper = styled(FlexView)`
  && {
    margin-top: 6px;
  }
`;

export const TraceToggleButton = styled.button`
  background: none;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 11px;
  color: #888;
  cursor: pointer;
`;

export const TraceContainer = styled(FlexView)`
  && {
    margin-top: 6px;
    padding: 10px;
    background: #f8f8f8;
    border: 1px solid #eee;
    border-radius: 6px;
    font-size: 11px;
    line-height: 1.6;
    font-family: monospace;
    max-height: 500px;
    overflow: auto;
  }
`;

export const LegacyTracePre = styled.pre`
  white-space: pre-wrap;
  margin: 0;
  font-size: 10px;
`;

export const TraceEventWrapper = styled(FlexView)`
  && {
    margin-bottom: 4px;
  }
`;

export const TraceEventHeader = styled(Row)`
  && {
    display: flex;
    align-items: baseline;
    gap: 6px;
  }
`;

export const TraceStepIcon = styled.span`
  display: inline-block;
  width: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  border-radius: 3px;
  background: ${({ $color }) => $color + '18'};
  color: ${({ $color }) => $color};
  font-size: 10px;
  font-weight: bold;
  flex-shrink: 0;
`;

export const TraceStepName = styled.strong`
  color: ${({ $color }) => $color};
`;

export const TraceDuration = styled.span`
  color: #999;
  font-size: 10px;
`;

export const TraceDataBlock = styled.div`
  margin-left: 20px;
  ${({ $muted }) => $muted && 'color: #666;'}
`;

export const TraceCollapsible = styled.details`
  margin-top: 2px;
  ${({ $indented }) => $indented && 'margin-left: 20px;'}
`;

export const TraceCollapsibleSummary = styled.summary`
  cursor: pointer;
  color: #666;
`;

export const TracePreBlock = styled.pre`
  white-space: pre-wrap;
  margin: 4px 0;
  font-size: 10px;
`;

export const TraceErrorText = styled.span`
  color: red;
`;

export const TraceMutedText = styled.span`
  color: #666;
`;

export const TraceDataEntry = styled.span`
  margin-right: 8px;
`;
